module.exports = __webpack_public_path__ + "img/ZHWLRJKF_5.3d305163.jpg";